<template>
  <div class="byg">
    <div style="background: #fff;">
      <div class="order_item van-hairline--bottom" v-for="item in goodsList" :key="item.productId">
        <div class="body">
          <span class="code">
            商品货号
            {{item.goodCode}}
          </span>
          <!-- <span class="size">白色 38码</span> -->
          <!-- <strong>x {{item.quantity}}</strong> -->

          <span class="detail-body">
            <div class="title">
              {{item.goodName}}
            </div>
            <div class="size">
              <div class="left">
                <!-- <span>白色 38码 </span> -->
                <strong>x {{item.quantity}}</strong>
              </div>
              <div class="right money">
                <span class="mini-code">￥<span class="max-code">{{item.actualPriceShow[0]}}</span>.{{item.actualPriceShow[1] || '00'}}</span>
              </div>
            </div>

          </span>
        </div>
      <div class="footer">
        <div class="right money" align="right">
          <span class="gray">商品总价</span>
          <span class=" mini-code address">￥
            <!-- <span class="max-code">4</span>.12 -->
            <span class="max-code">{{item.discountUnitPriceShow[0] || '0' }}</span>.{{item.discountUnitPriceShow[1] || '00'}}
          </span>
        </div>
      </div>

      </div>

    </div>
  </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
export default {
  data() {
    return {
      url: "",
      goodsList: []

    };
  },
  async mounted() {
    this.url = this.$route.query.pageType == 0 ? "/order/offline/appOrder/payList" : "/order/offline/appOrder/refundList"
    this.$loading.hide();
    this.getForm()
  },

  methods: {
    getForm() {
      http({
        url: this.url,
        method: "post",
        parmes: {
          payOrderId: this.$route.query.payOrderId,
          refundOrderId: this.$route.query.refundOrderId
        }
      }).then(rps => {
        if (rps.code === 200) {
          console.log(rps);
          let productVos = []
          if(this.$route.query.pageType == 0){
            productVos = rps.data.productVos
          }else{
            productVos = rps.data.list[0].productVos
          }
          this.error = false;
          this.isLoading = false;
          productVos.forEach(item => {
            item.actualPriceShow = String(item.unitPrice).split('.')
            item.discountUnitPriceShow = String(item.totalPrice).split('.')
          });
          this.goodsList = productVos
        }
      }).catch(rps => {
        // console.log(189181818);
        // let productVos = [
        //   {
        //     actualPrice: 0.01,
        //     discountUnitPrice: 0.01,
        //     goodCode: "goodCode",
        //     goodName: "goodName",
        //     productId: 7,
        //     quantity: 2,
        //   },
        //   {
        //     actualPrice: 0.01,
        //     discountUnitPrice: 0.01,
        //     goodCode: "goodCode",
        //     goodName: "goodName",
        //     productId: 7,
        //     quantity: 2,
        //   },

        // ]
        // productVos.forEach(item => {
        //   item.actualPriceShow = String(item.actualPrice).split('.')
        //   item.discountUnitPriceShow = String(item.discountUnitPrice).split('.')

        // });

        // this.goodsList = productVos
        // console.log(this.goodsList);

        this.error = true;
        this.isLoading = false;
      });
    },
    goDetailFun(id) {
      this.$router.push({
        path: "/orderBelowGoods",
        query: { id: 111 }
      });
    },
  },

};
</script>
<style lang="less" scoped>
  .byg {
    background: #f7f7f7;
    padding: 20px 20px 0 20px;
    font-size: 16px;
    .order_item {
      padding: 24px 20px;
      overflow: hidden;
    }
    .body {
      padding: 24px 0;
      font-size: 26px;
      display: flex;
      // align-items: center;
      &::after {
        border-bottom: 2px solid #e1e1e1;
      }
      .code {
        text-align: center;
        width: 120px;
        height: 120px;
        color: #333;
        border: 2px solid #f8d541;
        border-radius: 4px;
        background: rgba(248, 213, 65, 0.2);
        padding: 23px 25px;
        font-size: 28px !important;
        line-height: 38px;
        word-break: break-all;
        display: inline-block;
      }

      .detail-body {
        display: inline-block;
        padding-left: 20px;
        width: calc(100% - 190px);
        .title {
          font-size: 28px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }
        .size {
          color: #999;
          position: relative;
          bottom: -45px;
          display: flex;
        }
        strong {
          margin-left: 24px;
          color: #3b3a38;
        }
        .left {
          display: flex;
          flex: 1;
        }
      }
    }

    .money {
      font-size: 26px;
      color: #3b3a38;
      font-weight: 600;
      .mini-code {
        font-size: 24px;
      }
      .max-code {
        font-size: 32px;
      }
    }
    .address {
      color: #ed3939;
    }
    .gray {
      color: #999;
      margin-right: 10px;
      font-size: 24px;
      font-weight: 400;
    }
  }
</style>

